import(/* webpackMode: "eager" */ "/tmp/8de8b74867a3b99/app/[locale]/error.tsx");
